import { AlertCircle } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconAlertCircle(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <AlertCircle />
    </IconWrapper>
  );
}
